import { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

import {
    Input,
    SelectBox,
    ClassesDropdown,
    RichText,
    UploadForm,
} from "../Form";

import "./css/pop.css";

function getYouTubeId(url) {
    const regExp =
        /^.*(youtu.be\/|v\/|u\/\\w\/|embed\/|watch\?v=|&v=|shorts\/|live\/)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
}

export default function VideoInput({ setOpen, Open, onChange }) {
    const { t } = useTranslation();
    const [values, setvalues] = useState(false);
    const [tab, setTab] = useState(2);

    function save(val) {
        if ((!val?.video && !val?.youtube) || !val?.controll) {
            return alert(t("error", { returnObjects: true })[35]);
        }

        if (val?.youtube) {
            const id = getYouTubeId(val.youtube);
            val.youtube = id;
        }

        onChange({ type: Open, tab: tab, ...val });
        setOpen(false);
    }

    return (
        <div tabindex="-1" className="tiny_pop Video">
            <div className="tiny_body">
                <h3>{t("task_type_8")}</h3>

                <ul className="tabs">
                    <a
                        className={tab === 2 ? "ck" : ""}
                        onClick={() => setTab(2)}
                    >
                        {t("video_youtube")}
                    </a>
                    <a
                        className={tab === 1 ? "ck" : ""}
                        onClick={() => setTab(1)}
                    >
                        {t("video_upload")}
                    </a>
                </ul>
                <div style={{ padding: 20 }}>
                    {tab === 1 ? (
                        <UploadForm
                            title={t("choose_file")}
                            boxClass="imgCenterUpload"
                            onChange={(d) =>
                                setvalues((r) => ({
                                    ...r,
                                    video: d[0],
                                }))
                            }
                            value={[]}
                            accept=".mp4"
                        />
                    ) : (
                        <Input
                            title={t("youtube_link")}
                            onChange={(d) =>
                                setvalues((r) => ({
                                    ...r,
                                    youtube: d,
                                }))
                            }
                            value={values?.youtube}
                            style={{ direction: "ltr" }}
                            placeholder="https://www.youtube.com/watch?v=example"
                        />
                    )}

                    <SelectBox
                        validate={true}
                        title={t("video_opt")}
                        values={[
                            { name: t("video_type_1"), val: 1 },
                            { name: t("video_type_2"), val: 2 },
                        ]}
                        onChange={(d) =>
                            setvalues((p) => ({
                                ...p,
                                controll: d,
                            }))
                        }
                        value={values?.controll}
                        style={{ marginTop: 20 }}
                    />
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: 5,
                        padding: 20,
                    }}
                >
                    <button
                        onClick={(d) => setOpen(false)}
                        style={{ background: "#777", flex: 0.6 }}
                        className="btn "
                    >
                        {t("cancel")}
                    </button>
                    <button
                        onClick={(d) => save(values)}
                        style={{ flex: 1 }}
                        className="btn green"
                    >
                        {t("add")}
                    </button>
                </div>
            </div>
        </div>
    );
}
